export default {
    data: () => ({
        translations: {
            title: {
                el: "",
                en: "Store Coupons",
                it: ""
            },
            info: {
                el: "",
                en: `No matter your point system you can set rewarding coupons based your conditions for each store of yours.
                If you need to add, edit or delete your stores you can do it from the stores pages`,
                it: ""
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            purchasesGoal: {
                el: "Purchases Goal",
                en: "Purchases Goal",
                it: "Purchases Goal"
            },
            codeCoupon: {
                el: "Code Coupon",
                en: "Code Coupon",
                it: "Code Coupon"
            },
            productCoupon: {
                el: "Product Coupon",
                en: "Product Coupon",
                it: "Product Coupon"
            },
            discountCoupon: {
                el: "Discount Coupon",
                en: "Discount Coupon",
                it: "Discount Coupon"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            create: {
                el: "Δημιουργία Κουπονιού",
                en: "Create",
                it: "Creazione di coupon"
            },
            edit: {
                el: "ΕΠΕΞΕΡΓΑΣΙΑ",
                en: "Edit",
                it: "MODIFICARE"
            },
        }
    })
};
